import React from 'react';
import { CheckCircle2, Shield, TrendingUp, Users, Calculator } from 'lucide-react';
import { FadeInUp } from './FadeInUp';
const promises = [{
  icon: <CheckCircle2 className="w-6 h-6 text-vitality-green flex-shrink-0" data-id="element-1" />,
  text: 'Si calificas para un programa especializado en ahorros para familias como la tuya'
}, {
  icon: <Shield className="w-6 h-6 text-vitality-green flex-shrink-0" data-id="element-2" />,
  text: 'Cómo proteger a tu familia si algo inesperado pasa'
}, {
  icon: <TrendingUp className="w-6 h-6 text-vitality-green flex-shrink-0" data-id="element-3" />,
  text: 'Cómo hacer crecer tu dinero de forma más inteligente que el banco'
}, {
  icon: <Calculator className="w-6 h-6 text-vitality-green flex-shrink-0" data-id="element-4" />,
  text: 'Cómo construir un plan de retiro real, con números, ajustado a ti'
}, {
  icon: <Users className="w-6 h-6 text-vitality-green flex-shrink-0" data-id="element-5" />,
  text: 'Qué opciones tienes hoy según tu edad, familia y presupuesto'
}];
export function Benefits() {
  return <section className="bg-white py-24 relative" data-id="element-6">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-7">
        <FadeInUp data-id="element-8">
          <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-9">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-deep-blue mb-6 tracking-tight" data-id="element-10">
              En tu sesión privada de 15 minutos vas a descubrir:
            </h2>
            <div className="w-24 h-1.5 bg-vitality-green mx-auto rounded-full" data-id="element-11"></div>
          </div>
        </FadeInUp>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-12">
          {promises.map((item, index) => <FadeInUp key={index} delay={index * 0.1} data-id="element-13">
              <div className="flex items-center gap-6 bg-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 group relative overflow-hidden" data-id="element-14">
                <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-vitality-green transform origin-left scale-y-0 group-hover:scale-y-100 transition-transform duration-300" data-id="element-15"></div>

                <div className="flex-shrink-0 w-12 h-12 bg-green-50 rounded-full flex items-center justify-center" data-id="element-16">
                  {item.icon}
                </div>

                <p className="text-gray-800 text-lg leading-relaxed font-medium" data-id="element-17">
                  {item.text}
                </p>

                <div className="ml-auto text-gray-200 font-bold text-2xl opacity-50" data-id="element-18">
                  {String(index + 1).padStart(2, '0')}
                </div>
              </div>
            </FadeInUp>)}
        </div>
      </div>
    </section>;
}